import { useLocation, useNavigate } from "react-router-dom";
import { logo } from "../../assets";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import { newPathTitles } from "../../utils";
import * as authActions from "../../actions/AuthActions";
import { RiMenuFill } from "react-icons/ri";

const NavBar = ({
  title,
  setTitle,
  handleToggle,
  language,
  setLanguage,
  handleLanguageChange,
}) => {
  const location = useLocation();
  const isAuthenticated = useSelector(
    (state) => state.authReducer.isAuthenticated
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.authReducer.user);
  const token = useSelector((state) => state.authReducer.token);
  const refresh = useSelector((state) => state.authReducer.refresh);
  const handleLogout = async () => {
    const formData = new FormData();
    formData.append("refresh_token", refresh);
    const response = await authActions.customAction(
      "user/logout",
      "Logout",
      "post",
      formData,
      token
    );
    if (response) {
      dispatch(authActions.logout());
      navigate("/");
    }
  };

  useEffect(() => {
    setTitle(
      newPathTitles.filter((item) => item.path === location.pathname)[0]?.title
    );
  }, [location.pathname]);

  return (
    <div
      className={`d-flex bg-white position-fixed w-100 top-0 ${isAuthenticated ? "justify-content-between" : "justify-content-center"
        } align-items-center px-2 px-md-4 py-3`}
      style={{ border: "2px solid #F3F1F1", zIndex: 999 }}
    >
      <div className="d-flex align-items-center gap-10">
        <img
          onClick={() => navigate("/")}
          src={logo}
          alt=""
          className="select-none cursor-pointer"
        />
        {isAuthenticated && (
          <div className="d-none d-md-flex mx-5 px-2 fs-20 fw-600">{title}</div>
        )}
      </div>
      {isAuthenticated && (
        <>
          <div className="d-flex d-md-none align-items-center gap-20">
            <Button
              className="bg-transparent border-0 text-black"
              onClick={() => handleToggle()}
            >
              <RiMenuFill size={30} />
            </Button>
          </div>
          <div className="d-none d-md-flex align-items-center gap-20">
            <div>
              <select
                value={language}
                onChange={(e) => handleLanguageChange(e.target.value)}
                className="border-0"
              >
                <option value="en">English</option>
                <option value="tr">Turkish</option>
              </select>
            </div>
            <div
              onClick={() => navigate("/account")}
              className="fs-16 fw-500 cursor-pointer"
            >
              {"Hello"}, {user?.first_name}
            </div>
            <Button onClick={() => handleLogout()}> {"Logout"}</Button>
          </div>
        </>
      )}
    </div>
  );
};

export default NavBar;
